// Next.js runs this before any other client code, which is what makes it the one place for
// this: zod v4 probes `new Function("")` when it builds its first object schema (the AI SDK
// builds them at module scope), and the report-only CSP logs that probe as an 'unsafe-eval'
// violation on every page even though zod swallows the failure. `jitless` skips the probe;
// it must be set before the first schema is constructed, so it cannot live in a component.
import { config } from "zod";

config({ jitless: true });
